module.exports = __webpack_public_path__ + "img/物流-仓库运输双排.b258d751.jpg";